import Vue from 'vue';
const AlertsAPI = {
    // Fetch all alerts
    getAlerts() {
        return Vue.http.get('alerts/')
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    // Update an alert
    updateAlert(alert) {
        return Vue.http.patch(`alerts/${alert.id}/`, alert)
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    // Create an alert
    createAlert(alert) {
        return Vue.http.post('alerts/', alert)
            .then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    },
    // Delete an alert
    deleteAlert(id) {
        return Vue.http.delete(`alerts/${id}/`)
            .then((response) => Promise.resolve(), (error) => Promise.reject(error));
    }
};
export default AlertsAPI;
